import * as i0 from '@angular/core';
import { Injectable, forwardRef, Component, Input, ViewChildren, NgModule } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
const _c0 = ["ngxCheckbox"];
function NgxStarRatingComponent_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "input", 3, 0);
    i0.ɵɵlistener("click", function NgxStarRatingComponent_ng_template_1_Template_input_click_0_listener() {
      const star_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.rate(star_r2));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(2, "label", 4);
  }
  if (rf & 2) {
    const star_r2 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵclassMapInterpolate1("star star-", star_r2, "");
    i0.ɵɵpropertyInterpolate2("id", "star-", star_r2, "-", ctx_r2.id, "");
    i0.ɵɵproperty("checked", ctx_r2.value == star_r2)("disabled", ctx_r2.disabled);
    i0.ɵɵadvance(2);
    i0.ɵɵclassMapInterpolate1("star star-", star_r2, "");
    i0.ɵɵpropertyInterpolate2("for", "star-", star_r2, "-", ctx_r2.id, "");
  }
}
let NgxStarRatingService = /*#__PURE__*/(() => {
  class NgxStarRatingService {
    constructor() {}
  }
  NgxStarRatingService.ɵfac = function NgxStarRatingService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || NgxStarRatingService)();
  };
  NgxStarRatingService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: NgxStarRatingService,
    factory: NgxStarRatingService.ɵfac,
    providedIn: 'root'
  });
  return NgxStarRatingService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NgxStarRatingComponent = /*#__PURE__*/(() => {
  class NgxStarRatingComponent {
    constructor() {
      this.stars = [5, 4, 3, 2, 1];
      this.propagateChange = _ => {};
      if (!this.disabled) {
        this.disabled = false;
      }
    }
    ngOnInit() {}
    rate(rate) {
      if (!this.disabled) {
        this.propagateChange(rate);
      }
    }
    writeValue(value) {
      if (this.ngxCheckbox && value === null) {
        this.ngxCheckbox.forEach(checkbox => {
          checkbox.nativeElement.checked = false;
        });
      }
      this.value = value;
    }
    registerOnChange(fn) {
      this.propagateChange = fn;
    }
    registerOnTouched(fn) {}
  }
  NgxStarRatingComponent.ɵfac = function NgxStarRatingComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || NgxStarRatingComponent)();
  };
  NgxStarRatingComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: NgxStarRatingComponent,
    selectors: [["ngx-star-rating"]],
    viewQuery: function NgxStarRatingComponent_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.ngxCheckbox = _t);
      }
    },
    inputs: {
      id: "id",
      disabled: "disabled"
    },
    standalone: false,
    features: [i0.ɵɵProvidersFeature([{
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NgxStarRatingComponent),
      multi: true
    }])],
    decls: 2,
    vars: 1,
    consts: [["ngxCheckbox", ""], ["action", ""], ["ngFor", "", 3, "ngForOf"], ["type", "radio", "name", "star", 3, "click", "id", "checked", "disabled"], [3, "for"]],
    template: function NgxStarRatingComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelementStart(0, "form", 1);
        i0.ɵɵtemplate(1, NgxStarRatingComponent_ng_template_1_Template, 3, 14, "ng-template", 2);
        i0.ɵɵelementEnd();
      }
      if (rf & 2) {
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngForOf", ctx.stars);
      }
    },
    dependencies: [i1.NgForOf],
    styles: ["*[_ngcontent-%COMP%]{margin:0;padding:0;font-family:roboto}body[_ngcontent-%COMP%]{background:#000}.cont[_ngcontent-%COMP%]{width:93%;max-width:350px;text-align:center;margin:4% auto;padding:30px 0;background:#111;color:#eee;border-radius:5px;border:thin solid #444;overflow:hidden}hr[_ngcontent-%COMP%]{margin:20px;border:none;border-bottom:thin solid rgba(255,255,255,.1)}div.title[_ngcontent-%COMP%]{font-size:2em}h1[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{font-weight:300;color:#fd4}div.stars[_ngcontent-%COMP%]{width:270px;display:inline-block}input.star[_ngcontent-%COMP%]{display:none}label.star[_ngcontent-%COMP%]{float:right;padding:10px;font-size:36px;color:#444;transition:all .2s}input.star[_ngcontent-%COMP%]:checked ~ label.star[_ngcontent-%COMP%]:before{content:\"\\f005\";color:#fd4;transition:all .25s}input.star-5[_ngcontent-%COMP%]:checked ~ label.star[_ngcontent-%COMP%]:before{color:#fe7;text-shadow:0 0 20px #952}input.star-1[_ngcontent-%COMP%]:checked ~ label.star[_ngcontent-%COMP%]:before{color:#f62}label.star[_ngcontent-%COMP%]:hover{transform:rotate(-15deg) scale(1.3)}label.star[_ngcontent-%COMP%]:before{content:\"\\f006\";font-family:FontAwesome}"]
  });
  return NgxStarRatingComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NgxStarRatingModule = /*#__PURE__*/(() => {
  class NgxStarRatingModule {}
  NgxStarRatingModule.ɵfac = function NgxStarRatingModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || NgxStarRatingModule)();
  };
  NgxStarRatingModule.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: NgxStarRatingModule
  });
  NgxStarRatingModule.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    imports: [[CommonModule]]
  });
  return NgxStarRatingModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * Public API Surface of ngx-star-rating
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NgxStarRatingComponent, NgxStarRatingModule, NgxStarRatingService };
